(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ptichka-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ptichka-localization')) {
    customElements.define('ptichka-localization', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            details.open = false;
            summary.focus();
          }
        }, options);
        document.addEventListener('click', (event) => {
          if (details.open && !this.contains(event.target)) details.open = false;
        }, options);
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
